import { z } from 'zod'

export const costCenterSchema = z.object({
  id: z
    .number()
    .optional(),
  codigo: z
    .string()
    .refine(value => value.trim() !== "", "O código não pode ser vazio"),
  descricao: z
    .string()
    .min(3, "A descrição deve ter no mínimo 3 caracteres")
    .refine(value => value.trim() !== "", "A descrição não pode ser vazia"),
  alteracao: z
    .string()
    .optional(),
  inclusao: z.string().optional(),
  status: z.number().optional(),
  unidade: z.object({
    id: z.union([z.number().int(), z.string()])
  })
})

export type CostCenterFormSchema = z.infer<typeof costCenterSchema>
